// homepage
export const VISIT_HOMEPAGE = 'visit_homepage';
export const SHOW_PIN_REMINDER = 'pin_4to6digit_entrypage';
export const CLICK_UPDATE_PIN_6DIGIT = 'pin_4to6digit_entrypage_updatepin';
export const CLICK_LATER_PIN_6DIGIT = 'pin_4to6digit_entrypage_later';

// Pin
export const PIN_CHANGE_ACCOUNT = 'pin_change_account';
export const CLICK_FORGOT_PIN = 'forgot_pin_action';
export const CLICK_SUBMIT_PIN = 'click_submit_pin';
export const VISIT_PIN_PAGE = 'visit_pin_page';
export const CREATE_PIN_6DIGIT = 'pin_6digit_create';
export const CONFIRM_PIN_6DIGIT = 'pin_6digit_confirm';

// PIN — Mixpanel PIN event library. These run alongside the legacy PIN events above,
// which existing reports still read; do not replace one with the other.
export const PIN_INPUT_VIEW = 'pin_input_view';
export const PIN_INPUT_CLICK = 'pin_input_click';
export const PIN_VERIFYING = 'pin_verifying';
export const PIN_CREATE_VIEW = 'pin_create_view';
export const PIN_CREATE_SUBMIT = 'pin_create_submit';
export const PIN_RECONFIRM_VIEW = 'pin_reconfirm_view';
export const PIN_RECONFIRM_SUBMIT = 'pin_reconfirm_submit';
export const PIN_UPDATE_VIEW = 'pin_update_view';
export const PIN_UPDATE_SUBMIT = 'pin_update_submit';
export const PIN_UPDATE_BANNER_VIEW = 'pin_update_banner_view';
export const PIN_UPDATE_BANNER_CLICK = 'pin_update_banner_click';

export const PIN_APP_SOURCE = 'web-stock';

export const PIN_ENTRY_POINT = {
  REGISTRATION: 'registration',
  HARD_LOGIN: 'hard_login',
  SOFT_LOGIN: 'soft_login',
  LOGIN: 'login',
  SECURITY_MENU: 'security_menu',
};

export const PIN_INPUT_CLICK_TARGET = {
  FORGOT_PIN: 'forgot_pin',
  CHANGE_ACCOUNT: 'change_account',
};

export const PIN_UPDATE_BANNER_CLICK_TARGET = {
  SKIP: 'skip',
  UPDATE_PIN: 'update_pin',
};

export const PIN_UPDATE_BANNER_VARIANT = {
  OPTIONAL: 'optional',
  FORCE: 'force',
};

export const PIN_STATUS = {
  SUCCESS: 'success',
  FAIL: 'fail',
};

export const PIN_METHOD = {
  PIN: 'pin',
};

// OTP
export const CLICK_VERIFY_OTP = 'click_verifiy_otp';
export const CLICK_BACK_OTP = 'click_back_otp';
export const CLICK_RESEND_OTP = 'click_resend_otp';
export const VISIT_OTP_PAGE = 'visit_otp_page';

// Auto Order
export const CLICK_ATO = 'click_ato';
export const VISIT_ATO_BUY_PAGE = 'visit_ato_buy_page';
export const VISIT_ATO_SELL_PAGE = 'visit_ato_sell_page';
export const CLICK_BUY_ATO = 'click_buy_ato';
export const CLICK_SELL_ATO = 'click_sell_ato';
export const ATO_CREATED = 'ato_created';
export const SUCCESSFULLY_EDIT_ATO = 'successfully_edit_ato';
export const SUCCESSFULLY_DELETE_ATO = 'successfully_delete_ato';
export const CLICK_DELETE_ATO = 'click_delete_ato';
export const CLICK_EDIT_ATO = 'click_edit_ato';

// menu
export const CLICK_LOGOUT_CONFIRM = 'click_logout_confirm';
export const CLICK_PROFILE = 'click_profile';
export const CLICK_TOP_UP_BUTTON = 'click_top_up_button';

// Stock buy
export const CLICK_BUY_BUTTON = 'click_buy_button';
export const CLICK_SUBMIT_BUY_BUTTON = 'click_submit_buy_button';
export const CLICK_BUY_BUTTON_CONFIRM = 'click_buy_button_confirm';
export const CLICK_ORDER_PERIOD = 'click_order_period';
export const CLICK_LOT_PCT = 'click_lot_pct';
export const CLICK_ORDER_BOOK_PRICE = 'click_order_book_price';

// Stock sell
export const CLICK_SELL_BUTTON = 'click_sell_button';
export const CLICK_SUBMIT_SELL_BUTTON = 'click_submit_sell_button';
export const CLICK_SELL_BUTTON_CONFIRM = 'click_sell_button_confirm';

// stock trade-panel
export const VIEW_TRADE_PANEL = 'view_trade_panel';
export const CLICK_SWITCH_ORDER_SIDE = 'switch_order_side';
export const CLICK_SWITCH_ORDER_TYPE = 'switch_order_type';
export const ORDER_SEND_SUCCESS = 'order_send_success';
export const ORDER_SEND_FAIL = 'order_send_fail';
export const VIEW_INSUFFICIENT_ERROR = 'view_insufficient_error';
export const CLICK_INSUFFICIENT_CTA = 'click_insufficient_cta';
export const CLICK_SEARCH_DISCOVERY = 'click_search_discovery';

// stock amend
export const CLICK_AMEND_ORDER = 'click_amend_order';
export const CLICK_AMEND_ORDER_CONFIRM = 'click_amend_order_confirm';

// stock withdraw
export const CLICK_CANCEL_TRANSACTION = 'click_cancel_transaction';
export const CLICK_CANCEL_TRANSACTION_NO = 'click_cancel_transaction_no';
export const CLICK_CANCEL_TRANSACTION_YES = 'click_cancel_transaction_yes';

// mf buy
export const CLICK_UPLOAD_PAYMENT_PROOF = 'click_upload_payment_proof';
export const CLICK_BUY_MF_CONFIRM = 'click_buy_mf_confirm';
export const CLICK_BUY_MF_BUTTON = 'click_buy_mf_button';
export const CLICK_UPLOAD_PAYMENT_PROOF_CONFIRM = 'click_upload_payment_proof_confirm';
export const CLICK_KODE_PROMO = 'click_kode_promo';
export const CLICK_CHANGE_PAYMENT_METHOD = 'click_change_payment_method';
export const DEPOSIT_SUBMIT = 'deposit_submit';
export const DEPOSIT_CANCELLED = 'deposit_cancelled';

// mf sell
export const CLICK_SELL_MF_BUTTON = 'click_sell_mf_button';
export const CLICK_SELL_MF_CONFIRM = 'click_sell_mf_confirm';

// coin buy
export const CRYPTO_ATTEMPT_TO_BUY = 'crypto_attempt_to_buy';

// coin assets
export const CRYPTO_WITHDRAW_CHOOSE_ASSETS = 'crypto_withdraw_choose_assets';
export const CRYPTO_DEPOSIT_CHOOSE_ASSETS = 'crypto_deposit_choose_assets';

// coin deposit
export const CRYPTO_DEPOSIT_WALLET_ADDRESS = 'crypto_deposit_wallet_address';

// coin withdraw
export const CRYPTO_SEND = 'crypto_send';
export const CRYPTO_SEND_ALL = 'crypto_send_all';
export const CRYPTO_SEND_SAVE_ADDRESS = 'crypto_send_save_address';
export const CRYPTO_SEND_CONFIRMATION = 'crypto_send_confirmation';
export const CRYPTO_SEND_CONFIRMATION_CHECKBOX = 'crypto_send_confirmation_checkbox';
export const CRYPTO_SEND_SUCCESS = 'crypto_send_success';
export const CRYPTO_SEND_FAIL = 'crypto_send_fail';
export const CRYPTO_WALLET_ADDRESS = 'crypto_wallet_add_address';
export const CRYPTO_WALLET_ADDRESS_BOOK = 'crypto_wallet_address_book';
export const CRYPTO_WALLET_ADDRESS_SUCCESS = 'crypto_wallet_add_address_success';

// referral
export const CLICK_REFERRAL_LANDING_PAGE = 'click_referral_landing_page';
export const CLICK_REFERRAL_BONUS_HISTORY = 'click_referral_bonus_history';
export const CLICK_REFERRAL_TRACKER_REMIND = 'click_referral_tracker_remind';
export const CLICK_REFERRAL_REDEEM_COIN = 'click_referral_redeem_coin';
export const CLICK_REFERRAL_COPY_CODE = 'click_referral_copy_code';
export const CLICK_REFERRAL_SHARE_LINK = 'click_referral_share_link';
export const CLICK_REFERRAL_SHARE_POSTER = 'click_referral_share_poster';
export const CLICK_REFERRAL_SHARE_POSTER_MEDIA = 'click_referral_share_poster_media';

// kyc
export const CLICK_START_KYC = 'click_start_kyc';
export const KYC_BCA_FIRST_PAGE_SUBMIT = 'kyc_bca_first_page_submit';
export const KYC_PERMATA_SECOND_PAGE_SUBMIT = 'kyc_permata_second_page_submit';

export const KYC_FIRST_PAGE_SUBMIT = 'kyc_first_page_submit';
export const KYC_SECOND_PAGE_SUBMIT = 'kyc_second_page_submit';
export const KYC_THIRD_PAGE_SUBMIT = 'kyc_third_page_submit';
export const KYC_FOURTH_PAGE_SUBMIT = 'kyc_fourth_page_submit';
export const KYC_FIFTH_PAGE_SUBMIT = 'kyc_fifth_page_submit';
export const KYC_SIXTH_PAGE_SUBMIT_BCA = 'kyc_sixth_page_submit_bca';
export const KYC_SIXTH_PAGE_SUBMIT_PERMATA = 'kyc_sixth_page_submit_permata';

// kyc coin
export const CLICK_EXIST_CRYPTO_SUBMIT_PAGE = 'click_exist_crypto_submit_page';
export const CRYPTO_ACTIVATION_BUTTON = 'crypto_activation_button';
export const KYC_SUBMIT_COIN = 'kyc_submit_coin';

// detail page stock
export const CLICK_CA_SUBMENU = 'click_ca_submenu';
export const CLICK_STOCK_DETAIL_PAGE = 'click_stock_detail_page';
export const CLICK_SD_KEYSTAT_DETAILS = 'click_sd_keystat_details';
export const CLICK_SD_OVERVIEW = 'click_sd_overview';
export const CLICK_SD_TRADING_VIEW = 'click_sd_trading_view';
export const CLICK_SD_CHART_SWITCH = 'click_sd_chart_switch';
export const CLICK_STOCK_DETAIL_TAB = 'click_stock_detail_tab';

// news
export const CLICK_NEWS = 'click_news';
export const CLICK_KABAR = 'click_kabar';
export const SEARCH_NEWS = 'search_news';

// detail page mf
export const CLICK_MF_DETAIL = 'click_mf_detail';
export const CLICK_TREND_PERIOD = 'click_trend_period';
export const CLICK_PROSPECTUS_DETAILS = 'click_prospectus_details';
export const CLICK_FUND_FACT_DETAILS = 'click_fund_fact_details';

// detail page coin
export const CRYPTO_HOME = 'crypto_home';
export const CRYPTO_DETAIL_COIN_INFO = 'crypto_detail_coin_info';
export const CRYPTO_DETAIL_NEWS = 'crypto_detail_news';
export const CRYPTO_DETAIL_MARKET_PRICE = 'crypto_detail_market_price';

// dashboard
export const USER_CLICK_RESEND_EMAIL_VERIFICATION = 'user_click_resend_email_verification';

// discovery
export const CLICK_CALENDAR = 'click_calendar';
export const CLICK_STOCK_CATEGORY = 'click_stock_category';
export const CLICK_STOCK_SECTOR = 'click_stock_sector';
export const CLICK_MF_CATEGORY = 'click_mf_category';
export const CLICK_MF_TYPE = 'click_mf_type';
export const CLICK_COMPARE_ACTION = 'click_compare_action';

// discovery mf
export const CLICK_TOP_PERFORMER_FUNDS = 'click_top_performer_funds';
export const CLICK_TOP_PERFORMER_ALL = 'click_top_performer_all';
export const CLICK_TOP_PERFORMER_TOOLTIP = 'click_top_performer_tooltip';
export const CLICK_FUND_TYPE = 'click_fund_type';
export const CLICK_FUND_TYPE_TOOLTIP = 'click_fund_type_tooltip';
export const CLICK_FUND_MANAGER = 'click_fund_manager';
export const CLICK_FUND_MANAGER_TOOLTIP = 'click_fund_manager_tooltip';
export const CLICK_FUND_RETURN = 'click_fund_return';
export const CLICK_FUND = 'click_fund';
export const CLICK_HOVER_FUND = 'click_hover_fund';
export const CLICK_COMPARE = 'click_compare';
export const CLICK_COMPARISON_RESULTS = 'click_comparison_results';
export const CLICK_COMPARE_CANCEL = 'click_compare_cancel';

// discovery coin
export const CRYPTO_DISCOVERY = 'crypto_discovery';

// witdrawal
export const WITHDRAWAL_SUBMIT = 'withdrawal_submit';
export const WITHDRAWAL_CANCELLED = 'withdrawal_cancelled';

// portfolio
export const CLICK_PORTFOLIO = 'click_portfolio';

// rights portfolio
export const CLICK_RIGHTS_PORTFOLIO = 'click_rights_portfolio';
export const RIGHTS_EMPTY_STATE = 'rights_empty_state';
export const VISIT_RIGHTS_DETAIL = 'visit_rights_detail';
export const SUBMIT_RIGHTS = 'submit_rights';
export const CONFIRM_RIGHTS = 'confirm_rights';

// portfolio coin
export const CRYPTO_PORTFOLIO = 'crypto_portfolio';
export const CRYPTO_PORTFOLIO_TRADE_HISTORY = 'crypto_portfolio_trade_history';
export const CRYPTO_PORTFOLIO_NO_ASSET = 'crypto_portfolio_no_asset';
export const CRYPTO_PORTFOLIO_NOT_KYC = 'crypto_portfolio_not_kyc';
export const CRYPTO_GO_TO_KYC = 'crypto_go_to_kyc';

// transaction
export const CLICK_TRANSACTION = 'click_transaction';
export const CLICK_CANCEL_TRANSACTION_CONFIRM = 'click_cancel_transaction_confirm';
export const TRANSACTION_CANCELLED = 'transaction_cancelled';
export const CRYPTO_TRANSACTION = 'crypto_transaction';
export const CRYPTO_TRANSACTION_NOT_KYC = 'crypto_transaction_not_kyc';
export const CRYPTO_TRANSACTION_EMPTY = 'crypto_transaction_empty';
export const CRYPTO_CANCEL_CONFIRMARTION = 'crypto_cancel_confirmation';

// rdn
export const CLICK_TOP_UP_COPY_ACCOUNT_NUMBER = 'click_top_up_copy_account_number';

export const CLICK_CALCULATOR = 'click_calculator';

// update bank account
export const CLICK_CHANGE_BANK_ACCOUNT = 'click_change_bank_account';
export const CLICK_DETAIL_BANK_ACCOUNT_REQUEST = 'click_detail_bank_account_request';
export const CLICK_FAQ_BANK_ACCOUNT = 'click_faq_bank_account';
export const CLICK_CANCEL_BANK_ACCOUNT_REQUEST = 'click_cancel_bank_account_request';
export const CLICK_CONFIRM_CANCEL_BANK_ACCOUNT_REQUEST =
  'click_confirm_cancel_bank_account_request';
export const CLICK_REQUEST_BANK_ACCOUNT = 'click_request_bank_account';
export const CLICK_CONFIRM_BANK_ACCOUNT = 'click_confirm_bank_account';
export const CLICK_INPUT_SIGNATURE = 'click_input_signature';
export const CLICK_SUBMIT_BANK_ACCOUNT = 'click_submit_bank_account';
export const SUBMIT_BANK_ACCOUNT_SUCCESS = 'submit_bank_account_success';

// EIPO
export const VISIT_EIPO_DETAIL = 'visit_eipo_detail';
export const CLICK_ORDER_EIPO = 'click_order_eipo';
export const CLICK_REORDER_EIPO = 'click_reorder_eipo';
export const CLICK_TOP_UP_EIPO = 'click_top_up_eipo';
export const CLICK_SUBMIT_EIPO = 'click_submit_eipo';
export const CLICK_ADJUST_ORDER_EIPO = 'click_adjust_order_eipo';
export const CLICK_CONFIRM_EIPO = 'clik_confirm_eipo';
export const CLICK_TNC_EIPO = 'click_tnc_eipo';
export const CLICK_CHECKLIST_EIPO = 'click_checklist_tnc_eipo';
export const CLICK_CHECK_ORDER = 'click_check_order';
export const CLICK_TOTAL_DROPDOWN_EIPO = 'click_total_dropdown_eipo';
export const CLICK_FEE_TOOLTIP_EIPO = 'click_fee_tooltip_eipo';
export const CLICK_MATERAI_TOOLTIP_EIPO = 'click_materai_tooltip_eipo';

// help center
export const CLICK_HELP_CENTER_MENU = 'Click_HelpCenter_Menu';
export const CLICK_HELP_CENTER_SEARCHBAR = 'Click_HelpCenter_SearchBar';
export const CLICK_HELP_CENTER_SEARCH_NOT_FOUND = 'HelpCenter_SearchNotFound';
export const CLICK_HELP_CENTER_EMAIL = 'Click_Help_Email';

// On Going Process RDN
export const CLICK_RDN_PROCESSED_BUTTON = 'click_rdn_balance_processed';
export const VIEW_RDN_BALANCE_PROCESSED_PAGE = 'view_rdn_balance_processed_page';
export const CLICK_RDN_PROCESSED_BUTTON_CLOSE = 'click_rdn_balance_processed_close';

// Mf Auto Order
export const AUTO_SETOR_TOGGLE = 'auto_setor_toggle';
export const AUTO_SETOR_CLOSE_INFO = 'auto_setor_close_info';
export const AUTO_SETOR_FREQUENCY = 'auto_setor_frequency';
export const AUTO_SETOR_CREATE = 'auto_setor_create';
export const AUTO_SETOR_ADD = 'auto_setor_add';
export const AUTO_SETOR_SEARCH_FUND = 'auto_setor_search_fund';
export const AUTO_SETOR_CHOSEN_FUND = 'auto_setor_chosen_fund';
export const AUTO_SETOR_DETAIL_VISIT = 'auto_setor_detail_visit';
export const AUTO_SETOR_DELETE = 'auto_setor_delete';
export const AUTO_SETOR_UPDATE = 'auto_setor_update';
export const AUTO_SETOR_REQUEST_UPDATE = 'auto_setor_request_update';
export const AUTO_SETOR_SUCCESS_UPDATE = 'auto_setor_success_update';
export const AUTO_SETOR_CANCEL_UPDATE = 'auto_setor_cancel_update';
export const AUTO_SETOR_REQUEST_DELETE = 'auto_setor_request_delete';
export const AUTO_SETOR_CANCEL_DELETE = 'auto_setor_cancel_delete';

// PEP EDD
export const VISIT_EDD_PAGE = 'visit_page_edd_permata';
export const CLICK_START_EDD = 'click_start_edd_permata';
export const CLICK_LANJUT_EDD = 'click_lanjut_edd';

// trusted device
export const SHOW_TRUSTED_DEVICE = 'show_trusted_device';
export const REMOVE_DEVICE = 'remove_device';
